import React from 'react'
import Sports from '@mui/icons-material/Sports'
import SportsTennis from '@mui/icons-material/SportsTennis'
import SportsSoccer from '@mui/icons-material/SportsSoccer'
import SportsBasketball from '@mui/icons-material/SportsBasketball'
import SportsVolleyball from '@mui/icons-material/SportsVolleyball'
import SportsHockey from '@mui/icons-material/SportsHockey'
import SportsHandball from '@mui/icons-material/SportsHandball'
import SportsBaseball from '@mui/icons-material/SportsBaseball'
import SportsCricket from '@mui/icons-material/SportsCricket'
import SportsFootball from '@mui/icons-material/SportsFootball'
import SportsRugby from '@mui/icons-material/SportsRugby'
import SportsGolf from '@mui/icons-material/SportsGolf'
import GolfCourse from '@mui/icons-material/GolfCourse'
import SportsMma from '@mui/icons-material/SportsMma'
import SportsMartialArts from '@mui/icons-material/SportsMartialArts'
import SportsKabaddi from '@mui/icons-material/SportsKabaddi'
import SportsGymnastics from '@mui/icons-material/SportsGymnastics'
import SportsMotorsports from '@mui/icons-material/SportsMotorsports'
import SportsEsports from '@mui/icons-material/SportsEsports'
import SportsScore from '@mui/icons-material/SportsScore'
import SportsBar from '@mui/icons-material/SportsBar'
import FitnessCenter from '@mui/icons-material/FitnessCenter'
import SelfImprovement from '@mui/icons-material/SelfImprovement'
import DirectionsRun from '@mui/icons-material/DirectionsRun'
import DirectionsWalk from '@mui/icons-material/DirectionsWalk'
import DirectionsBike from '@mui/icons-material/DirectionsBike'
import NordicWalking from '@mui/icons-material/NordicWalking'
import Hiking from '@mui/icons-material/Hiking'
import Pool from '@mui/icons-material/Pool'
import ScubaDiving from '@mui/icons-material/ScubaDiving'
import Surfing from '@mui/icons-material/Surfing'
import Kitesurfing from '@mui/icons-material/Kitesurfing'
import Sailing from '@mui/icons-material/Sailing'
import Rowing from '@mui/icons-material/Rowing'
import Kayaking from '@mui/icons-material/Kayaking'
import DownhillSkiing from '@mui/icons-material/DownhillSkiing'
import Snowboarding from '@mui/icons-material/Snowboarding'
import Snowshoeing from '@mui/icons-material/Snowshoeing'
import Sledding from '@mui/icons-material/Sledding'
import Snowmobile from '@mui/icons-material/Snowmobile'
import Skateboarding from '@mui/icons-material/Skateboarding'
import Paragliding from '@mui/icons-material/Paragliding'
import GpsFixed from '@mui/icons-material/GpsFixed'
import Casino from '@mui/icons-material/Casino'
import Park from '@mui/icons-material/Park'
import Toys from '@mui/icons-material/Toys'
import EmojiEvents from '@mui/icons-material/EmojiEvents'
import Groups from '@mui/icons-material/Groups'
import School from '@mui/icons-material/School'
import Event from '@mui/icons-material/Event'
import AcUnit from '@mui/icons-material/AcUnit'
import Flag from '@mui/icons-material/Flag'

import { ReactComponent as SdkBadminton } from './sdkicons/Badminton.svg'
import { ReactComponent as SdkBasketball } from './sdkicons/Basketball.svg'
import { ReactComponent as SdkBeachVolley } from './sdkicons/BeachVolley.svg'
import { ReactComponent as SdkBilliard } from './sdkicons/Billiard.svg'
import { ReactComponent as SdkBoxing } from './sdkicons/Boxing.svg'
import { ReactComponent as SdkFloorball } from './sdkicons/Floorball.svg'
import { ReactComponent as SdkFootball } from './sdkicons/Football.svg'
import { ReactComponent as SdkGolf } from './sdkicons/Golf.svg'
import { ReactComponent as SdkGymnastics } from './sdkicons/Gymnastics.svg'
import { ReactComponent as SdkIcehockey } from './sdkicons/Icehockey.svg'
import { ReactComponent as SdkPadel } from './sdkicons/Padel.svg'
import { ReactComponent as SdkPickleball } from './sdkicons/Pickleball.svg'
import { ReactComponent as SdkSquash } from './sdkicons/Squash.svg'
import { ReactComponent as SdkTableTennis } from './sdkicons/TableTennis.svg'
import { ReactComponent as SdkTennis } from './sdkicons/Tennis.svg'
import { ReactComponent as SdkTrackAndField } from './sdkicons/TrackAndField.svg'
import { ReactComponent as SdkVolleyball } from './sdkicons/Volleyball.svg'
import { ReactComponent as SdkWeightLifting } from './sdkicons/WeightLifting.svg'

// An icon is identified by a pair: `icontype` says which vocabulary the name belongs
// to, `icon` is the name inside it. Both are plain strings, so the value stays portable
// to consumers (enduser app, exports) that map the pair to their own asset.
//
//   ICONTYPE_SDK : falcon-sdk sport icon, name from its SPORT_ICON_NAMES ('tennis', 'icehockey', …)
//   ICONTYPE_MUI : @mui/icons-material component name ('SportsGolf', 'DirectionsBike', …)
//
// Data written before icontype existed is read as MUI.
export const ICONTYPE_SDK = 'sdk'
export const ICONTYPE_MUI = 'mui'

// Keyed by the SDK's canonical names, not by the file names — 'gym' is WeightLifting.svg,
// and gymnastics / trackandfield ship as assets without being in SPORT_ICON_NAMES.
export const SDK_SPORT_ICONS = {
  badminton: SdkBadminton,
  basketball: SdkBasketball,
  beachvolley: SdkBeachVolley,
  billiard: SdkBilliard,
  boxing: SdkBoxing,
  floorball: SdkFloorball,
  football: SdkFootball,
  golf: SdkGolf,
  gym: SdkWeightLifting,
  gymnastics: SdkGymnastics,
  icehockey: SdkIcehockey,
  padel: SdkPadel,
  pickleball: SdkPickleball,
  squash: SdkSquash,
  tabletennis: SdkTableTennis,
  tennis: SdkTennis,
  trackandfield: SdkTrackAndField,
  volleyball: SdkVolleyball,
}

export const SPORT_ICONS = {
  Sports,
  SportsTennis,
  SportsSoccer,
  SportsBasketball,
  SportsVolleyball,
  SportsHockey,
  SportsHandball,
  SportsBaseball,
  SportsCricket,
  SportsFootball,
  SportsRugby,
  SportsGolf,
  GolfCourse,
  SportsMma,
  SportsMartialArts,
  SportsKabaddi,
  SportsGymnastics,
  SportsMotorsports,
  SportsEsports,
  SportsScore,
  SportsBar,
  FitnessCenter,
  SelfImprovement,
  DirectionsRun,
  DirectionsWalk,
  DirectionsBike,
  NordicWalking,
  Hiking,
  Pool,
  ScubaDiving,
  Surfing,
  Kitesurfing,
  Sailing,
  Rowing,
  Kayaking,
  DownhillSkiing,
  Snowboarding,
  Snowshoeing,
  Sledding,
  Snowmobile,
  Skateboarding,
  Paragliding,
  GpsFixed,
  Casino,
  Park,
  Toys,
  EmojiEvents,
  Groups,
  School,
  Event,
  AcUnit,
  Flag,
}

export const SPORT_ICON_NAMES = Object.keys(SPORT_ICONS).sort()
export const SDK_SPORT_ICON_NAMES = Object.keys(SDK_SPORT_ICONS).sort()

export const DEFAULT_ICON_NAME = 'Sports'
export const DEFAULT_ICONTYPE = ICONTYPE_MUI

// Every selectable icon as an { icontype, name } pair, SDK icons first.
export const ICON_OPTIONS = [
  ...SDK_SPORT_ICON_NAMES.map((name) => ({ icontype: ICONTYPE_SDK, name })),
  ...SPORT_ICON_NAMES.map((name) => ({ icontype: ICONTYPE_MUI, name })),
]

export function isSameIcon(a, b) {
  return a && b && a.name === b.name && a.icontype === b.icontype
}

// Unknown names fall back to the generic MUI icon so a value written by another
// tool never breaks the rendering.
export function getSportIconComponent(name, icontype) {
  if (icontype === ICONTYPE_SDK) return SDK_SPORT_ICONS[name] || SPORT_ICONS[DEFAULT_ICON_NAME]
  return SPORT_ICONS[name] || SPORT_ICONS[DEFAULT_ICON_NAME]
}

const FONT_SIZES = { small: 20, large: 35 }

export default function SportIcon({ name, icontype, fontSize, size, strokeWidth, ...props }) {
  const Icon = getSportIconComponent(name, icontype)
  if (icontype === ICONTYPE_SDK && SDK_SPORT_ICONS[name]) {
    // Plain SVG, not an MUI SvgIcon: size it the way MUI's fontSize prop would and
    // let it inherit the text colour through stroke='currentColor'. The drawn
    // stroke-width of 25 on a 1024 box is left alone — it stays legible down to
    // 20px, and thickening it fills in the detailed icons (tennis strings, running
    // track lanes) into a solid blob.
    const px = size || FONT_SIZES[fontSize] || 24
    return (
      <Icon
        width={px}
        height={px}
        {...(strokeWidth ? { strokeWidth } : {})}
        style={{ verticalAlign: 'middle' }}
        {...props}
      />
    )
  }
  return <Icon fontSize={fontSize} {...props} />
}
